import $ from "jquery";

const handleToggleClick = (e) => {
  const $toggleButtonEl = $(e.currentTarget); // e.currentTarget is safer for buttons
  const toggleNearestCl = $toggleButtonEl.attr("data-accordion-toggle");

  if (!toggleNearestCl) {
    return;
  }

  let $toggleEl = $toggleButtonEl.parent().siblings(`.${toggleNearestCl}`);

  if ($toggleEl.length === 0) {
    $toggleEl = $toggleButtonEl.siblings(`.${toggleNearestCl}`);
  }

  let txt = $toggleButtonEl.text().replace(/\s+/g, " ").trim();
  let dataLayer = (window.dataLayer = window.dataLayer || []);
  dataLayer.push({
    faqQuestion: txt,
    event: "faqClick",
  });

  const isExpanded = $toggleButtonEl.attr("aria-expanded") === "true";

  if (isExpanded) {
    // Close the item
    $toggleButtonEl.attr("aria-expanded", "false");
    $toggleEl.attr("aria-hidden", "true");
    $toggleEl.parent().parent().removeAttr("data-open");
    $toggleEl.css("max-height", "0");
  } else {
    // Open the item
    const maxHeight = $toggleEl[0].scrollHeight;
    $toggleButtonEl.attr("aria-expanded", "true");
    $toggleEl.attr("aria-hidden", "false");
    $toggleEl.parent().parent().attr("data-open", "true");
    $toggleEl.css("max-height", `${maxHeight}px`);
  }
};

function accordionToggle() {
  $("[data-accordion-toggle]").each(function () {
    const $button = $(this);
    $button.attr("aria-expanded", "false"); // Set initial state
    const toggleNearestCl = $button.attr("data-accordion-toggle");
    const $toggleEl = $button
      .parent()
      .siblings(`.${toggleNearestCl}`)
      .add($button.siblings(`.${toggleNearestCl}`));
    $toggleEl.attr("aria-hidden", "true"); // Set initial state for content
  });

  $("[data-accordion-toggle]").on("click", handleToggleClick);
}

export default accordionToggle;
